<style lang="scss">

@font-face {
  font-family: 'DM Serif Display';
  src: url('/fonts/DMSerifDisplay-Italic.ttf') format('truetype');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

:root {
  --bottom-nav-height: 70px;
  --input-padding: 10px 16px;
  --label-padding: 8px 0px;
  --margin-base: 8px 0px;
  --global-radius: 16px;
  --inner-padding: 20px;
  --list-padding: 16px 40px;
  --spacing: 10px;
  --spacing-medium: 20px;
  --global-padding: 30px;
  --small-padding: 8px 16px;
  /* colors */
  --white: #ffffff;
  --grey-lighter: #f3f4f5;
  --grey-light: #d5dde5;
  --grey: #949494;
  --text: #474747;
  --text-light: #838383;
  --red: #ea3f58;
  --red-dark: #c42751;
  --pink: #fc1571;
  --pink-dark: #de1f5b;
  --orange: #fe777d;
  --yellow: #feb884;
  --green: #bae38f;
  --green-dark: #1adbd5;
  --green-darker: #84cc75;
  --blue: #30a6f0;
  --blue-dark: #6338ff;
  --purple: #9914e0;
  --purple-dark: #6338ff;
}
html {
    height: 100%;
    min-height: 100%;
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
  -webkit-appearance: none;
}
* {
  box-sizing: border-box;
}
body, #app {
    background: #ffffff;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    color: var(--text);
    padding: 0px;
    margin: 0px;
    min-height: 100vh;
    height: 100vh;
    box-sizing: border-box;
    line-height: 1.5rem;

    /* iOS Fixes */
    // padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
    // padding-top: env(safe-area-inset-top); /* iOS 11.2 */
    -webkit-touch-callout: none !important;
    -webkit-user-select: none !important;
    user-select: none !important;

    .is-ios {
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      -webkit-tap-highlight-color: transparent;
      -webkit-appearance: none;
      appearance: none;
    }

    &.security-wall-modal-open {
      overflow: hidden;
    }
}
body.with-maps, #app.with-maps, #main.with-maps {
  background: transparent !important;
}
.ios-notch {
  padding-top: constant(safe-area-inset-top); /* iOS 11.0 */
  padding-top: env(safe-area-inset-top) !important; /* iOS 11.2 */
}
.ios-notch-or-padding-top {
  padding-top: max(env(safe-area-inset-top), var(--global-padding)) !important;
}
.alert-danger,
.alert-info {
  padding: var(--inner-padding);
  border-radius: var(--global-radius);
}
.alert-danger {
  background: var(--pink);
  color: white;
}
.alert-info {
  background: var(--yellow);
  color: var(--text);
}
main {
  display: grid;
  grid-template: 'main';
  overflow: hidden;

  > *:not(footer) {
    grid-area: main;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    header + div {
      flex: 1;
      padding-top: 1rem;
      padding-bottom: 1rem;
      overflow: auto;
    }
  }

  &.has-bottom-nav > *:not(footer) {
    padding-bottom: var(--bottom-nav-height);
  }

  &.has-install-banner {
    padding-top: 120px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.2s;
  transition-property: transform;
  transition-timing-function: linear;
}

.slide-left-enter,
.slide-right-leave-active {
  transform: translateX(100%);
}

.slide-left-leave-active,
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-down-enter-active,
.slide-down-leave-active,
.slide-up-enter-active,
.slide-up-leave-active {
  transition-duration: 0.2s;
  transition-property: transform;
  transition-timing-function: linear;
}

.slide-down-enter,
.slide-up-leave-active {
  transform: translateY(100%);
}

.slide-down-leave-active,
.slide-up-enter {
  transform: translateY(100%);
}
a {
    color: var(--pink);
    text-decoration: none;
    outline: none;
}
button {
  outline: none;
}
.btn {
  display: inline-block;
  padding: var(--input-padding);
  border-radius: var(--global-radius);
  border: 0px;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  background: var(--grey-light);
  line-height: 1.15;
}
.btn-plain {
  background: transparent;
  color: var(--text);
}
.btn-white-outlined {
  border: 2px solid var(--white);
  color: white;
}
.btn-white-with-border {
  background-color: #fff;
  border: 2px solid var(--grey-light);
}
.btn-edit {
  display: flex;
  background: transparent;
  padding: 8px 0 0;
  font-size: 14px;
  color: var(--blue);

  svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;

    path {
      fill: var(--blue);
    }
  }
}
.btn-icon-and-text {
  display: inline-flex;
  align-items: center;
  border-radius: 30px;
  padding: 8px 14px 8px 10px;
}
.btn.fixed-btn {
  position: fixed;
  right: 0;
  bottom: 0;
  padding: 24px 50px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-right-radius: 0px;
  border-top-left-radius: 40px;
}
.close {
  width: 20px;
  height: 20px;
  display: block;
}
textarea {
  outline: none;
}
svg {
  outline: none;
}
img {
  max-width: 100%;
  vertical-align: middle;
  height: auto;
}
.inline {
  display: inline-block;
}
.padding {
    padding: var(--global-padding);
}
.small-padding {
    padding: var(--small-padding);
}
.no-pt {
    padding-top: 0px !important;
}
.no-pb {
    padding-bottom: 0px !important;
}
.no-outline {
  outline: none;
}
.margin {
    margin: 20px;
}
.mv {
    margin-top: 20px;
    margin-bottom: 20px;
}
.mh {
    margin-left: 20px;
    margin-right: 20px;
}
.full-height {
    min-height: 100vh;
}
.fixed {
    position: fixed;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
@media (max-width: 350px) {
  .hide-small {
    display: none;
  }
}
.max-width {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
}

.progressbar-bar {
  background: white;
  height: 9px;
  transition: transform 1s ease;
  position: relative;
  top: -4px;
}
ul {
  padding-left: 20px;
  li {
    padding: 8px 0px;
  }
}

/* HORIZONTAL SCROLL */

.horizontal-scroll {
    overflow-x: scroll;
    white-space: nowrap;
    width: 100%;
    max-width: 100%;
}
.horizontal-scroll .block {
    margin: 0 10px;
    display: inline-flex;
}
.horizontal-scroll .block .card {
    padding: var(--spacing-medium);
    flex-wrap: wrap;
    flex-direction: column;
}
.horizontal-scroll .block:first-of-type {
    margin-left: 0px;
}
.horizontal-scroll .block .card div {
    display: block;
    white-space: pre-wrap;
}
.horizontal-scroll .add-btn {
    display: inline-flex;
    position: relative;
    transform: translateY(5%);
    margin-left: var(--spacing);
}
.shadow {
  -webkit-box-shadow: 1px 1px 14px 3px rgba(71,71,71,0.1);
  -moz-box-shadow: 1px 1px 14px 3px rgba(71,71,71,0.1);
  box-shadow: 1px 1px 14px 3px rgba(71,71,71,0.1);
}

/* FLEXBOX */

.row {
    display: flex;
    flex-direction: row;
}
.column {
    display: flex;
    flex-direction: column;
}
.vertical-center {
    align-items: center;
}
.vertical-bottom {
    align-items: flex-end;
}
.vertical-start {
    align-items: flex-start;
}
.horizontal-end {
  justify-content: flex-end;
}
.horizontal-center {
    justify-content: center;
}
.horizontal-between {
    justify-content: space-between;
}
.horizontal-around {
  justify-content: space-around;
}
.wrap {
    flex-wrap: wrap;
}
.col {
    flex: 1;
}
.grid {
    display: grid;
    grid-gap: 20px;
}

/* HEADERS */

header {
    width: 100%;
    z-index: 10;
    top: 0;
    left: 0;
    .padding {
      padding: var(--inner-padding) var(--spacing);
    }
    .title-lg {
      font-weight: 600;
    }
}
.header-offset {
    padding-top: 80px;
}
.title, .title-lg {
  font-family: 'DM Serif Display', serif;
}
.back {
    margin-right: 10px;
    height: 24px;
    path {
      fill: var(--text);
    }
}
.refresh {
    margin-left: 10px;
    height: 24px;
    path {
      fill: var(--text);
    }
}
@media (min-width: 700px) {
  header .title {
    text-align: center;
    padding-right: 34px;
  }
}

/* CARDS */

.card {
    border-radius: var(--global-radius);
    background: var(--white);
    display: flex;
    overflow: hidden;
    color: var(--text);
    position: relative;
}
.card-body {
    padding: var(--inner-padding);
    position: relative;
}
.card-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgb(0,0,0);
    background: linear-gradient(3deg, rgba(0,0,0,0.7399334733893557) 0%, rgba(0,0,0,0) 84%);
}
.card-img-left {
    min-width: 100px;
    max-width: 100px;
    overflow: hidden;
    min-height: 100%;
}
.card-img-left img {
    display: block;
    max-width: 400px;
    max-height: 100px;
    width: auto;
    height: auto;
    aspect-ratio: 1 / 1;
    object-fit: cover;
}
.card-img-bg {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}
.card-img-bg img {
    width: auto;
    height: auto;
}
.card-bg-opacity {
    opacity: .1;
}
.card-locked {
    opacity: .4;
}
.card-locked:before {
    content: '';
}
.square {
    width: 130px;
    height: 130px;
}

@media (min-width:700px) {
  .square {
    width: 200px;
    height: 200px;
  }
}

/* INPUT */
.form-field {
  padding: var(--margin-base);
}
select, option, input {
  -webkit-appearance: none;
  appearance: none;
}
.select-wrapper {
  position: relative;
}
.select-wrapper:after {
  content: '';
  right: 14px;
  top: 50%;
  height: 24px;
  width: 24px;
  transform: translateY(-50%);
  background: url(assets/chevron-down.svg);
  position: absolute;
  pointer-events: none;
}
input[type="text"],
input[type="date"],
input[type="time"],
input[type="email"],
input[type="number"],
input[type="password"],
input[type="search"],
select,
textarea {
  .is-ios & {
    font-size: 16px; // Prevent iOS from zooming in
  }
  outline-color: var(--purple-light);
}

input[type="checkbox"],
input[type="text"],
input[type="date"],
input[type="time"],
input[type="email"],
input[type="number"],
input[type="password"],
select,
textarea,
.file-input,
.switch-container {
  outline: none;
}

input[type="text"],
input[type="date"],
input[type="time"],
input[type="email"],
input[type="number"],
input[type="password"],
select,
textarea {
  padding: var(--input-padding);
  border-radius: var(--global-radius);
  border: 1px solid var(--grey-light);
  width: 100%;
  font-family: inherit;

  &.is-invalid {
    border-color: var(--pink);
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--grey-light);
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 24px;

    &:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 4px;
      bottom: 4px;
      background-color: var(--white);
      -webkit-transition: .4s;
      transition: .4s;
      border-radius: 50%;
    }
  }
}

input:checked + .slider {
  background-color: var(--green-dark);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--green-dark);
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

[type=radio] {
  -webkit-appearance: radio;
  appearance: radio;
}

[type=checkbox] {
  -webkit-appearance: checkbox;
  appearance: checkbox;
}

label {
  display: block;
  padding: var(--label-padding);
}

/* OTHER */

.list-item {
    border-bottom: 1px solid var(--grey-light);
    padding: var(--list-padding);
}
.list-item .desc {
    opacity: .7;
}
.list-img, .add-btn {
    width: 50px;
    height: 50px;
    border-radius: var(--global-radius);
    background-color: var(--text);
    overflow: hidden;
    margin-right: 10px;
}
.list-item .actions {
    margin-left: 10px;
    height: 20px;
}
.list-item .actions img, .list-item .actions svg {
    margin-left: 10px;
}
.add-new {
    padding: 10px 30px;
}
.play-game {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    text-align: center;
    padding: 20px;
}
.play-media {
    // width: ;
    // height: ;
    background: var(--white);
    border-radius: 50%;
}
.profile-img, .profile-img-lg, .profile-img-sm {
    border-radius: 50%;
    overflow: hidden;
    width: 40px;
    height: 40px;
}
.profile-img-lg {
    width: 90px;
    height: 90px;
}
.profile-img-sm {
    width: 30px;
    height: 30px;
}

/* FONT SIZES */

.title { font-size: 24px; line-height: 28px; }
.title-lg { font-size: 32px; }
.title-md { font-size: 20px; }
.title-sm { font-size: 18px; }
.title-caps { font-size: 14px; text-transform: uppercase; font-weight: bold; letter-spacing: 1px; }
.text-md { font-size: 14px; }
.text-sm { font-size: 12px; }

.muted {
  opacity: .8;
}

.primary { color: var(--text); }
.secondary { color: var(--text-light); }

/* BG COLORS */

.white { background-color: var(--white); }
.grey { background-color: var(--grey-lighter); }
.grey-light { background-color: var(--grey-light); }
.pink { background-color: var(--pink); }
.pink-dk { background-color: #F43892; }
.orange { background-color: var(--orange); }
.purple { background-color: var(--purple); }
.purple-dk { background-color: var(--purple-dark); }
.blue { background-color: var(--blue); }
.blue-dk { background-color: #42ACF9; }
.green { background-color: var(--green); }
.green-dk { background-color: var(--green-dark); }
.pink, .pink-dk, .purple, .purple-dk, .blue, .blue-dk, .green, .green-dk, .orange {
    color: var(--white);
}

/* GRADIENTS */

.gradient1 {
  color: white;
  background: var(--pink);
  background: linear-gradient(0deg, var(--yellow) 0%, var(--pink) 100%);
}
.gradient2 {
  color: white;
  background: var(--green-dark);
  background: linear-gradient(0deg, var(--green) 0%, var(--green-dark) 100%);
}
.gradient3 {
  color: white;
  background: var(--blue);
  background: linear-gradient(0deg, var(--green-dark) 0%, var(--blue) 100%);
}
.gradient4 {
  color: white;
  background: var(--purple);
  background: linear-gradient(0deg, var(--purple) 0%, var(--blue-dark) 100%);
}
.gradient5 {
  color: white;
  background: var(--purple);
  background: linear-gradient(0deg, var(--pink) 0%, var(--purple) 100%);
}
.gradient1-90 {
  color: white;
  background: var(--pink);
  background: linear-gradient(90deg, var(--pink) 0%, var(--yellow) 100%);
}
.gradient2-90 {
  color: white;
  background: var(--green-dark);
  background: linear-gradient(90deg, var(--green-dark) 0%, var(--green) 100%);
}
.gradient3-90 {
  color: white;
  background: var(--blue);
  background: linear-gradient(90deg, var(--blue) 0%, var(--green-dark) 100%);
}
.gradient4-90 {
  color: white;
  background: var(--purple);
  background: linear-gradient(90deg, var(--blue-dark) 0%, var(--purple) 100%);
}

/* FOOTER */

footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    box-shadow: 0 -1px 4px rgba(162,162,162,0.2);
    line-height: 1rem;
}
footer nav {
    height: calc(env(safe-area-inset-bottom) + var(--bottom-nav-height));
    font-size: 12px;
    text-align: center;
}
footer nav a {
    display: block;
    padding: 16px 0px;
    color: var(--text);
}
footer nav a svg {
  width: 20px;
}
footer nav .nav-item {
  color: var(--grey);
  path {
    fill: var(--grey);
  }
}
footer nav a.nav-us.router-link-active {
  color: #252525;
  path {
    fill: #252525;
  }
}
footer nav a.nav-play.router-link-active {
  color: var(--pink);
  path {
    fill: var(--pink);
  }
}
footer nav a.nav-discover.router-link-active {
  color: var(--purple);
  path {
    fill: var(--purple);
  }
}
footer nav a.nav-dream.router-link-active {
  color: var(--blue);
  path {
    fill: var(--blue);
  }
}
footer nav a.nav-dream svg {
  width: 18px;
}
footer nav .nav-learn {
  position:relative;
}
footer nav a.nav-learn.router-link-active {
  color: var(--green-dark);
  path {
    fill: var(--green-dark);
  }
}
footer nav a.nav-learn svg {
  width: 21px;
}
footer nav a.nav-chat.router-link-active {
  color: var(--purple-dark);
  path {
    fill: var(--purple-dark);
  }
}
footer nav a.nav-chat svg {
  width: 23px;
}
footer nav span {
    display: block;
}
.top-buttons {
  position: fixed;
  top: calc(env(safe-area-inset-top) + 0px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--global-padding);
  width: 100%;
}
.bottom-buttons {
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 0px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--global-padding);
  width: 100%;
}
.learn-unread-bubble {
  width: 16px;
  height: 16px;
  background: var(--green-dark);
  color: white;
  border-radius: 50%;
  display: block;
  text-align: center;
  line-height: 16px;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 11px;
}

/* REVIEW POPUP */
#review {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    z-index: 100;
    box-shadow: 0 -1px 4px rgba(162,162,162,0.2);
    line-height: 1rem;
}
#review nav {
    height: var(--bottom-nav-height);
    font-size: 12px;
    text-align: center;
}

/* MISC */
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.visibility-hidden {
  visibility: hidden;
}
.rotate-180 {
  transform: rotate(180deg);
}
@media (max-width:350px) {
  :root {
    --inner-padding: 20px;
    --global-padding: 30px;
    --list-padding: 8px 30px;
  }
}
.install-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  padding: 12px 16px;
  z-index: 1001;
  max-height: 120px;
  overflow: hidden;
}

.install-content {
  text-align: center;
}

.app-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 6px;

  img {
    max-width: 96px;
    width: auto;
    height: auto;
  }
}

.app-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  flex-shrink: 0;
}

.app-name {
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.app-message {
  margin: 0 0 12px 0;
  color: #666;
  font-size: 13px;
}

.install-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.install-btn {
  background: #007AFF;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.install-btn:hover {
  background: #0056CC;
}

.dismiss-btn {
  background: transparent;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
}

.dismiss-btn:hover {
  background: #f5f5f5;
}
</style>

<template>
  <div id="app">
    <div v-if="showInstallButton" class="install-banner">
      <div class="install-content">
        <div class="app-info">
          <img src="/img/icons/apple-touch-icon.png" alt="Intimately Us app icon">
          <div>
            <h3>Install Intimately Us</h3>
            <div class="install-actions">
              <button @click="installApp" class="install-btn">
                Install App
              </button>
              <button @click="dismissInstall" class="dismiss-btn">
                Maybe Later
              </button>
            </div>
          </div>
        </div>
        <p class="app-message">Get quick access and a better experience!</p>
      </div>
    </div>
    <main
      id="main"
      :class="{ 'has-bottom-nav': !routesWithoutBottomNav.includes($route.name),
                'ios-notch' : !routesWithoutNotchPadding.includes($route.name),
                'grey' : routesWithGrayNotch.includes($route.name),
                'purple-dk' : routesWithPurpleNotch.includes($route.name),
                'has-install-banner': showInstallButton }"
    >
      <transition :name="transitionName">
        <keep-alive :include="keepAliveComponents" :key="$store.state.keepAliveKey">
          <router-view/>
        </keep-alive>
      </transition>
      <transition name="slide-up">
        <review-prompt id="review" @review="reviewCompleted" v-if="promptReview" />
      </transition>
      <transition name="slide-up">
        <upgrade-prompt id="review" @complete="upgradePromptCompleted" v-if="promptUpgrade" />
      </transition>
      <footer
        v-show="!routesWithoutBottomNav.includes($route.name) && !menuShowing"
        class="white"
        role="navigation"
        aria-label="Main navigation"
      >
        <nav class="row vertical-start white">
          <div class="col">
            <router-link
              to="/home"
              class="nav-item nav-us"
              :aria-label="$t('App.us')"
              :aria-current="$route.path === '/home' ? 'page' : null"
            >
                <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" @click="resetPlayClicks(), resetPositionClicks()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 2.69l5 4.5V15h-2V9H7v6H5V7.19l5-4.5zM10 0L0 9h3v8h6v-6h2v6h6V9h3L10 0z" fill="#000"/></svg>
                <span>{{ $t('App.us') }}</span>
            </router-link>
          </div>
          <div class="col">
            <router-link
              to="/play"
              class="nav-item nav-play"
              :aria-label="$t('App.play')"
              :aria-current="$route.path === '/play' ? 'page' : null"
            >
                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" @click="countPlayClicks(), resetPositionClicks()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.5 3.64L7.77 7 2.5 10.36V3.64zM.5 0v14l11-7" fill="#000"/></svg>
                <span>{{ $t('App.play') }}</span>
            </router-link>
          </div>
          <div class="col">
            <router-link
              to="/discover"
              class="nav-item nav-discover"
              :aria-label="$t('Discover.discover')"
              :aria-current="$route.path === '/discover' ? 'page' : null"
            >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" @click="resetPlayClicks(), countPositionClicks()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M1 10h4a5 5 0 1110 0h4a1 1 0 010 2H1a1 1 0 010-2zm2 4h14a1 1 0 010 2H3a1 1 0 010-2zm12 4a1 1 0 010 2H5a1 1 0 010-2h10zm-2-8a3 3 0 00-6 0h6zM10 0l2.39 3.42C11.65 3.15 10.84 3 10 3c-.84 0-1.65.15-2.39.42L10 0zM1.34 5l4.16-.35A7.2 7.2 0 003.94 6.5c-.44.74-.69 1.5-.83 2.29L1.34 5zm17.31 0l-1.77 3.79a7.023 7.023 0 00-2.38-4.15l4.15.36z" fill="#000"/></svg>
                <span>{{ $t('Discover.discover') }}</span>
            </router-link>
          </div>
          <div class="col">
            <router-link
              to="/dream"
              class="nav-item nav-dream"
              :aria-label="$t('App.dream')"
              :aria-current="$route.path === '/dream' ? 'page' : null"
            >
                <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" @click="resetPlayClicks(), resetPositionClicks()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.75 3.09l-2.53 1.94.91 3.06-2.63-1.81-2.63 1.81.91-3.06-2.53-1.94L10.44 3l1.06-3 1.06 3 3.19.09zm3.5 6.91l-1.64 1.25.59 1.98-1.7-1.17-1.7 1.17.59-1.98L13.75 10l2.06-.05L16.5 8l.69 1.95 2.06.05zm-2.28 4.95c.83-.08 1.72 1.1 1.19 1.85-.32.45-.66.87-1.08 1.27C13.17 22 6.84 22 2.94 18.07c-3.91-3.9-3.91-10.24 0-14.14.4-.4.82-.76 1.27-1.08.75-.53 1.93.36 1.85 1.19-.27 2.86.69 5.83 2.89 8.02a9.96 9.96 0 008.02 2.89zm-1.64 2.02a12.08 12.08 0 01-7.8-3.47c-2.17-2.19-3.33-5-3.49-7.82-2.81 3.14-2.7 7.96.31 10.98 3.02 3.01 7.84 3.12 10.98.31z" fill="#000"/></svg>
                <span>{{ $t('App.dream') }}</span>
            </router-link>
          </div>
          <div class="col">
            <router-link
              to="/learn"
              class="nav-item nav-learn"
              :aria-label="$t('Learn.learn') + (unreadArticles ? ` (${unreadArticles} unread)` : '')"
              :aria-current="$route.path === '/learn' ? 'page' : null"
            >
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" @click="resetPlayClicks(), resetPositionClicks()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 0L0 6l4 2.18v6L11 18l7-3.82v-6l2-1.09V14h2V6L11 0zm6.82 6L11 9.72 4.18 6 11 2.28 17.82 6zM16 13l-5 2.72L6 13V9.27L11 12l5-2.73V13z" fill="#000"/></svg>
                <span class="learn-unread-bubble" v-if="unreadArticles" aria-hidden="true">{{ (unreadArticles > 9) ? "9+" : unreadArticles }}</span>
                <span>{{ $t('Learn.learn') }}</span>
            </router-link>
          </div>
          <div class="col">
            <a
              href="javascript:void(0);"
              onclick="window.open('https://justbetweenus.app/r/iu', '_system')"
              class="nav-item nav-chat"
              v-if="$store.state.autoLaunchChat"
              :aria-label="$t('App.chat') + ' (opens in new window)'"
              rel="noopener"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 002.75 5.5c0 .6-.42 2.17-2.75 4.5 2.37-.11 4.64-1 6.47-2.5 1.14.33 2.34.5 3.53.5 5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6m5-5v-2h-2v2h2m-4 0v-2h-2v2h2m-4 0v-2H7v2h2z"/></svg>
                <span>{{ $t('App.chat') }}</span>
            </a>
            <router-link
              to="/chat"
              class="nav-item nav-chat"
              v-else
              :aria-label="$t('App.chat')"
              :aria-current="$route.path === '/chat' ? 'page' : null"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 3C6.5 3 2 6.58 2 11a7.218 7.218 0 002.75 5.5c0 .6-.42 2.17-2.75 4.5 2.37-.11 4.64-1 6.47-2.5 1.14.33 2.34.5 3.53.5 5.5 0 10-3.58 10-8s-4.5-8-10-8m0 14c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6m5-5v-2h-2v2h2m-4 0v-2h-2v2h2m-4 0v-2H7v2h2z"/></svg>
                <span>{{ $t('App.chat') }}</span>
            </router-link>
          </div>
        </nav>
      </footer>
    </main>
    <security-wall
      v-if="appLocked"
      @closed="securityWallClosed"
    />
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import SecurityWall from './components/SecurityWall';
import ReviewPrompt from './components/ReviewPrompt';
import UpgradePrompt from './components/UpgradePrompt';
import {setToken} from './global_methods/api';
import getDeviceData from './methods/device_data';
import { PushNotifications } from '@capacitor/push-notifications';
import { Badge } from '@capawesome/capacitor-badge';
import firebaseMixin from './mixins/firebase_functions';
import { LocalNotifications } from '@capacitor/local-notifications';
import { App } from '@capacitor/app';

export default {
  data () {
      return {
        appLocked: false,
        isNavMenuOpen: false,
        profilePhotoKeySuffix: 0,
        routesWithoutBottomNav: [
          'welcome',
          'sign_up',
          'request_push_perms',
          'login',
          'logout',
          'password_change',
          'password_reset',
          'profile_photo_change',
          'profile_update',
          'background_photo_change',
          'annoucements',
          'bedroomgame',
          'battlestrip',
          'battlestrip_game',
          'connect4play',
          'exploration_list',
          'exploration_pack',
          'exploration_compare_pack',
          'conversation_starters',
          'learn_article',
          'inapppurchase',
          'expertqa_detail',
          'expertqa',
          'playlist',
          'playlist_detail',
          'bedroom_language',
          'bucket_list',
          'love_list',
          'fantasies_list',
          'memories_list',
          'escapes_list',
          'escapes_detail',
          'conquests',
          'feedback',
          'settings',
          'sync',
          'sizes_list',
          'dateideas_list',
          'dateideas_detail',
          'stories_list',
          'stories_detail',
          'invites',
          'calendar',
          'challenge_settings',
          'twister',
          'sextember',
          'charades',
          'positions',
          'position-categories',
          'position-detail',
          'positions-web',
        ],
        routesWithoutNotchPadding: [
          'home',
          'escapes_detail',
          'inapppurchase',
          'welcome',
          'sign_up',
          'sync',
          'restore_purchases',
          'battlestrip_game',
          'connect4play',
          'dateideas_detail',
          'learn_article',
        ],
        routesWithGrayNotch: [
          'play',
          'discover',
          'dream',
          'learn',
          'positions',
          'position-categories',
        ],
        routesWithPurpleNotch: [
          'sextember',
          'calendar',
          'leaderboard',
          'badges',
          'intimacy_score',
        ],
        transitionName: '',
        promptReview: false,
        promptUpgrade: false,
        playClicks: 0,
        positionClicks: 0,
        deferredPrompt: null,
        showInstallButton: false,
      }
  },
  components: {
    SecurityWall,
    ReviewPrompt,
    UpgradePrompt,
  },
  mixins: [firebaseMixin],
  computed: {
    userData () {
        return this.$store.state.userData;
    },
    whatsNewData () {
      return this.$store.state.whatsNewData;
    },
    menuShowing () {
      return this.$store.state.menuShowing;
    },
    unreadArticles() {
      let newArticles = 0;
      const at = this.$store.state.learnArticleTimestamps;
      for (const value of Object.values(at)) {
        if (value.read === false) {
          newArticles++;
        }
      }
      return newArticles;
    },
    appPlatform () {
      return this.$store.state.appPlatform;
    },
    keepAliveComponents() {
      return ['Learn', 'Home', 'Play', 'Dream', 'Discover', 'DateIdeas', 'Positions'];
    },
  },
  watch: {
    $route(from, to) {
      this.isNavMenuOpen = false;
      if (this.$store.state.upgradePromptPoints > 10 && this.userData && !this.isPremium()) {
        this.$store.commit('upgradePromptPoints', 0);
        this.promptUpgrade = true;
      }
      if (from.meta && to.meta) {
        if (from.meta.level > to.meta.level) {
          this.transitionName = 'slide-left';
        }
        else {
          this.transitionName = 'slide-right';
        }
      } else {
        this.transitionName = 'slide-right';
      }
    },
    userData(newValue, oldValue) {
      if (
        newValue &&
        oldValue &&
        newValue.profile_photo !== oldValue.profile_photo
      ) {
        this.profilePhotoKeySuffix++;
      }

      // Initialize CDV Purchase store when user logs in
      if (newValue && !oldValue && window.cordova) {
        this.$store.dispatch('initializeCdvPurchaseStore');
      }
    },
    'userData.drf_token'() {
      console.log('drf_token changed', this.userData);
      if (this.userData && this.userData.drf_token) {
        setToken(this.userData.drf_token);
      }
    },
  },
  async created () {
    this.promptToUnlock();

    // set initial token value
    if (this.userData) {
      setToken(this.userData.drf_token);

      if (window.cordova) {
        fetch(
          `${API_URL}users/device/`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ${this.userData.drf_token}`,
            },
            body: JSON.stringify(await getDeviceData()),
          }
        );

        if (this.userData.appstore_uuid) {
          window.store.applicationUsername = this.userData.appstore_uuid;
        } else {
          window.store.applicationUsername = this.userData.email;
        }

        window.cordova.plugins.SingularCordovaSdk.setCustomUserId(this.userData.id);
      }
    } 

    App.addListener('resume', this.promptToUnlock);
    App.addListener("resume", async () => {
      if (window.cordova && this.$route.path != '/') {
        PushNotifications.removeAllDeliveredNotifications();
        await Badge.clear();
      }
    });

    if (window.cordova) {
      // Clear any notifications
      if (this.$route.path != '/') {
        PushNotifications.removeAllDeliveredNotifications();
        await Badge.clear();
      }

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.yearly',
          value: { type: window.CdvPurchase.store.PAID_SUBSCRIPTION, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.yearly2',
          value: { type: window.CdvPurchase.store.PAID_SUBSCRIPTION, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.annual',
          value: { type: window.CdvPurchase.store.PAID_SUBSCRIPTION, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.monthly',
          value: { type: window.CdvPurchase.store.PAID_SUBSCRIPTION, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.monthly2',
          value: { type: window.CdvPurchase.store.PAID_SUBSCRIPTION, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.monthly3',
          value: { type: window.CdvPurchase.store.PAID_SUBSCRIPTION, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.onetime',
          value: { type: window.CdvPurchase.store.NON_CONSUMABLE, pricing: {} },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.lifetime',
          value: { type: window.CdvPurchase.store.NON_CONSUMABLE, pricing: {} },
        },
      );

      const cdvPurchasePlatform = this.appPlatform === 'android' ? window.CdvPurchase.Platform.GOOGLE_PLAY : window.CdvPurchase.Platform.APPLE_APPSTORE;

      Object.entries(this.$store.state.inAppPurchaseProducts).forEach(([id, data]) => {
        window.CdvPurchase.store.register({
          id,
          type: data.type,
          platform: cdvPurchasePlatform,
        });
      });

      window.CdvPurchase.store.when().productUpdated((product) => {
        if (product.id !== 'com.getyourmarriageon.i') {
          this.$store.commit(
            'inAppPurchaseProducts',
            {
              key: product.id,
              value: product,
            },
          );
        }
      }).approved((transaction) => {
        transaction.verify();
      }).verified((receipt) => {
        window.appEventBus.emit('receiptVerified', receipt);

        receipt.finish();

        if (this.userData !== null) {
          this.$store.commit('userData', receipt.raw.user_data);
        }
      });

      window.CdvPurchase.store.validator = `${API_URL}iap-validator/`;

      if (this.userData) {
        this.$store.dispatch('initializeCdvPurchaseStore');
      }
    } else {
      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.monthly',
          value: {
            price: '4.99',
            currency: 'USD',
            name: 'Monthly Access',
            period: 'month',
            stripePriceId: 'price_1RtGipCTG9dtuz8paXgpea8B',

          },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.yearly',
          value: {
            price: '39.99',
            currency: 'USD',
            name: 'Yearly Access',
            period: 'year',
            stripePriceId: 'price_1RtGj7CTG9dtuz8py1mxHNuG',
          },
        },
      );

      this.$store.commit(
        'inAppPurchaseProducts',
        {
          key: 'com.getyourmarriageon.i.onetime',
          value: {
            price: '49.99',
            currency: 'USD',
            name: 'Lifetime Access',
            period: 'forever',
            stripePriceId: 'price_1RtGjpCTG9dtuz8pDWFxpf5h',
            pricing: {
              price: '$49.99',
              currency: 'USD',
            },
          },
        },
      );
    }
  },
  async mounted () {
    window.localNotifications = LocalNotifications
    if (window.Keyboard && window.Keyboard.disableScroll) {
      window.Keyboard.disableScroll(false);
    }

    // PUSH NOTIFICATION SETUP
    if (this.userData) {
      if (window.cordova) {
        this.handleFirebase();
      } else {
        this.handleFirebaseWeb();

        // See if there's a ref in the URL query parameter. If so, commit the 'referredBy' state store
        if (window.location.search.includes('ref=')) {
          const ref = window.location.search.split('ref=')[1];
          this.$store.commit('referredBy', ref);
        }
      }   
    } 

    if (window.cordova && window.Branch) {
      App.addListener('resume', this.BranchInit);
      this.BranchInit();
    }

    if (window.cordova && window.cordova.plugins.SingularCordovaSdk) {
      this.SingularInit();
    }

    // Fetch ads from the ad service
    let response;
    try {
      response = await fetch(
        `${API_URL}adservice/`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    }
    catch (e) { console.log(e); }

    if (response && response.status == 200) {
      let adArray = await response.json();
      this.$store.commit('adList', adArray);
    }

    // Prompt install on PWA version
    if (!window.cordova) {
      window.addEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
      window.addEventListener('appinstalled', this.handleAppInstalled);
      
      if (window.matchMedia('(display-mode: standalone)').matches) {
        console.log('Standalone mode detected');
      }
    }


    // See what's new
    let whatsNewResponse;
    let url = `${API_URL}whatsnew/latest_entry/`;

    if (this.whatsNewData.latestEntry) {
      url += `?latest_known_id=${this.whatsNewData.latestEntry.id}`;
    }

    try {
      whatsNewResponse = await fetch(url);
    }
    catch(e) {} // eslint-disable-line no-empty

    if (whatsNewResponse && whatsNewResponse.status == 200) {
      let latestEntryData = await whatsNewResponse.json();

      if (latestEntryData.total_entries) {
        let showIndicator;

        if (
          this.whatsNewData.latestEntry === null ||
          latestEntryData.latest_entry.id < this.whatsNewData.latestEntry.id
        ) {
          showIndicator = false;
        }
        else {
          showIndicator = true;
        }

        this.$store.commit('whatsNewData', {
          showIndicator,
          latestEntry: latestEntryData.latest_entry,
          totalEntries: latestEntryData.total_entries,
          latestReadEntryId: this.whatsNewData.latestReadEntryId,
        });
      }
    }

    // Get new articles
    let articleResponse;
    try {
      articleResponse = await fetch(`${API_URL}learn/timestamp/`);
    }
    catch(e) {} // eslint-disable-line no-empty

    if (articleResponse && articleResponse.status == 200) {
      let atList = await articleResponse.json();
      if (JSON.stringify(this.$store.state.learnArticleTimestamps) == '{}') {
        let at = new Object(); // at is 'article timestamps'
        for (let item of atList) {
          at[item.id] = {
            timestamp: Date.parse(item.timestamp),
            read: true,
            category: item.category,
          }
        }
        this.$store.commit('learnArticleTimestamps', at);
      } else {
        // Check for new articles and add them to our object
        let at = this.$store.state.learnArticleTimestamps;
        for (let item of atList) {
          if (!(item.id in at)) {
            at[item.id] = {
              timestamp: Date.parse(item.timestamp),
              read: false,
              category: item.category,
            }
          } else {
            if (Date.parse(item.timestamp) > at[item.id].timestamp) {
              at[item.id].read = false;
            }
          }
        }
        // // Add up all the items that are unread
        // for (const [key, value] of Object.entries(at)) {
        //   if (value.read === false) {
        //     this.learnNewArticles++;
        //   }
        // }
        // commit our new object
        this.$store.commit('learnArticleTimestamps', at);
      }
    }

    // Remind the user to sync with their spouse if they haven't done so yet
    // Do this up to 3 three times
    if (window.cordova &&
        this.userData &&
        !this.userData.spouse &&
        this.$store.state.syncReminder > 0 &&
        this.$store.state.syncReminder < 4) {

      let t = new Date();
      t.setHours(14);
      t.setMinutes(10);
      t.setMilliseconds(0);

      LocalNotifications.schedule({
        notifications: [
          {
            id: 1,
            title: this.$t('App.sync-with-your-sweetheart'),
            body: this.$t('App.invite-your-lover-to-sync-with-you-and-begin-using-intimately-us'),
            schedule: {
              at: new Date(t.setDate(t.getDate() + (this.$store.state.syncReminder + 1)))
            },
          }
        ]
      })


      // increment by one so that we don't bother them
      this.$store.commit('syncReminder', this.$store.state.syncReminder + 1);
    }

		// Increment number of opens and determine if we should prompt for a review
		let reviewObj = this.$store.state.reviewData;
		reviewObj.counter++;
		this.$store.commit('reviewData', this.$store.state.reviewData)

		// Prompt for a review on the fourth open or every 12th open thereafter
		if (['', 'later'].includes(reviewObj.status) && window.cordova) {
			if (reviewObj.counter == 6 || reviewObj.counter % 12 == 0) {
				this.promptReview = true;
			}
		}
  },
  methods: {
    promptToUnlock() {
      if (this.$store.state.securityWall.enabled) {
        if (this.$store.state.timestampBeforeTemporaryPause) {
          // We recorded the date and time that the user left the app to
          // do something such as choose an image to attach. If they
          // were quick about it, we will not prompt them to unlock the
          // app. But if they were not quick about it (perhaps they got
          // interrupted with a phone call, for example), we will prompt
          // them to unlock the app.

          let maxSeconds = 180;
          let seconds = (new Date() - this.$store.state.timestampBeforeTemporaryPause) / 1000;
          this.$store.commit('timestampBeforeTemporaryPause', null);

          if (seconds > maxSeconds) {
            this.appLocked = true;
          }
        }
        else {
          this.appLocked = true;
        }
      }
    },
    securityWallClosed() {
      // The "setTimeout" exists because Adam was running into an issue
      // without it. On his Pixel 3, the biometrics prompt would pop
      // right back up even though it was successfully dealt with.

      setTimeout(() => {
        this.appLocked = false;
      }, 100);
    },
    goToRoute(to) {
      this.isNavMenuOpen = false;
      this.$router.push(to);
    },
		reviewCompleted(howEnded) {
			let reviewObj = this.$store.state.reviewData;
			reviewObj.status = howEnded;
			this.$store.commit('reviewData', reviewObj);
			this.promptReview = false;
    },
		upgradePromptCompleted(userResponse) {
      this.promptUpgrade = false;
      if (userResponse) {
        this.$router.push('/inapppurchase');
      }
    },
    async SingularInit() {
      // Create the configuration object
      var singularConfig = new
      window.cordova.plugins.SingularCordovaSdk.SingularConfig("getyourmarriageon_497690ca", "8f1eb35d2167c179c42b9cd8eeaa4a28");

      /*
      // Optional: Enable deep linking (requires additional setup steps, see guide)
      var linkHandler = function(data){
      var deeplink = data.deeplink;
      var passthrough = data.passthrough;
      var isDeferred = data.isDeferred;
      // Add link handling logic here
      }
      singularConfig.withSingularLink(linkHandler);
      */

      // To enable META Install Referrer
      singularConfig.withFacebookAppId("1034473614467424");

      // Optional: Enable SKAdNetwork (in Managed Mode, see guide for more options)
      singularConfig.withSkAdNetworkEnabled(true);

      // Initialize Singular
      window.cordova.plugins.SingularCordovaSdk.init(singularConfig);
    },
    handleBranchDeepLink(res) {
      // Extract referral code
      const refMatch = res['$canonical_url'].match(/ref=(.*)$/);
      if (refMatch && refMatch.length === 2) {
        this.$store.commit('referredBy', refMatch[1]);
        return;
      }

      // Only navigate if user is logged in
      if (!this.userData) return;

      // Extract article ID
      const articleMatch = res['$canonical_url'].match(/articleId=(.*)$/);
      if (articleMatch && articleMatch.length === 2) {
        const articleId = articleMatch[1];
        if (this.$route.path !== `/learn/article/${articleId}`) {
          this.$router.push({
            name: 'learn_article',
            params: {id: articleId},
          });
        }
        return;
      }

      // Extract date idea ID
      const dateMatch = res['$canonical_url'].match(/date=(.*)$/);
      if (dateMatch && dateMatch.length === 2) {
        const dateId = dateMatch[1];
        if (this.$route.path !== `/discover/date-ideas/${dateId}`) {
          this.$router.push({
            name: 'dateideas_detail',
            params: {id: dateId}
          });
        }
        return;
      }

      // Extract position ID
      const positionMatch = res['$canonical_url'].match(/position=(.*)$/);
      if (positionMatch && positionMatch.length === 2) {
        const positionId = positionMatch[1];
        if (this.$route.path !== `/discover/positions/${positionId}`) {
          this.$router.push({
            name: 'position-detail',
            params: {id: positionId}
          });
        }
        return;
      }

      // Check for upgrade path
      if (res['$canonical_url'].match(/upgrade$/)) {
        if (this.$route.path !== '/inapppurchase') {
          this.$router.push({
            name: 'inapppurchase',
          });
        }
      }
    },
    async BranchInit() {
      await window.Branch.disableTracking(false);
      await window.Branch.setCookieBasedMatching("r.intimately.us");
      window.Branch.initSession()
        .then((res) => {
          localStorage.setItem("branchDebug", JSON.stringify(res, null, 2));
          if (res['+clicked_branch_link']) {
            this.handleBranchDeepLink(res);
          }
        })
        .catch(async () => {
          const res = await window.Branch.getLatestReferringParams();
          localStorage.setItem("branchDebug", JSON.stringify(res, null, 2));
          if (res['+clicked_branch_link']) {
            this.handleBranchDeepLink(res);
          }
        });
    },
    resetPlayClicks() {
      this.playClicks = 0;
    },
    countPlayClicks() {
      this.playClicks++;
      if (this.playClicks >= 5) {
        this.$store.commit('showPlayExtra', true);
      }
    },
    resetPositionClicks() {
      this.positionClicks = 0;
    },
    countPositionClicks() {
      this.positionClicks++;
      if (this.positionClicks >= 5) {
        this.$store.commit('showPositions', true);
      }
    },
    handleBeforeInstallPrompt(event) {

      event.preventDefault();
      this.deferredPrompt = event;

      this.showInstallButton = true;
    },
    handleAppInstalled() {
      this.showInstallButton = false;
      this.deferredPrompt = null;
    },
    async installApp() {
      if (!this.deferredPrompt) {
        return;
      }

      // Show the install prompt
      this.deferredPrompt.prompt();

      // Wait for the user to respond to the prompt
      const userChoice = await this.deferredPrompt.userChoice;

      if (userChoice.outcome === 'accepted') {
        console.log('User accepted the installation prompt');
      } else {
        console.log('User dismissed the installation prompt');
      }

      this.deferredPrompt = null;
      this.showInstallButton = false;
    },
    dismissInstall() {
      this.showInstallButton = false;
      // Possibly request the user to install it again in the future
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.handleBeforeInstallPrompt);
    window.removeEventListener('appinstalled', this.handleAppInstalled);

    // Remove Capacitor event listeners to prevent memory leaks
    if (window.cordova) {
      App.removeAllListeners('resume');
    }
  }
}
</script>
